/**
 * Created by r4zi4l on 22.08.2022
 */

const CupsConfig = {};

// a cup registers its type here from its own feature, so a type is present only when the game runs that feature
CupsConfig.TYPES = {};

CupsConfig.IsEnabled = function (type) {
    return Boolean(CupsConfig.TYPES[type]);
};

if (typeof cc === "undefined") {
    module.exports = CupsConfig;
}
